import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap';
import router from './routes/index';
import { createPinia } from 'pinia';
import Vue3Toastify from 'vue3-toastify';
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
/* import specific icons */
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
/* add icons to the library */
library.add(fab, far, fas);
// Importa estilos SCSS globales
import '@/assets/styles/global.scss';
var pinia = createPinia();
createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon)
    .use(pinia)
    .use(router)
    .use(Vue3Toastify, {
    autoClose: 7000,
})
    .mount('#app');
// Fetch user profile when app starts
import { useAuthStore } from './stores/authStore';
var authStore = useAuthStore();
authStore.fetchUser();
